import { render, staticRenderFns } from "./TabWithdrawApprove.vue?vue&type=template&id=0c38c742&scoped=true&"
import script from "./TabWithdrawApprove.vue?vue&type=script&lang=js&"
export * from "./TabWithdrawApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38c742",
  null
  
)

export default component.exports